import {
  GroupMultiSelectPropsType,
  GroupOptionsItemType,
  GroupChildrenItemType,
} from './type';

export const getAllKeys = (list: Array<GroupOptionsItemType>) => {
  const optKeyList: Array<string> = [];
  list?.forEach((items: GroupOptionsItemType) => {
    items.children?.forEach((item: GroupChildrenItemType) => {
      optKeyList.push(item.value);
    });
  });
  return optKeyList;
};

export const optionsToMap = (list: Array<GroupOptionsItemType>) => {
  let result = {};
  list?.forEach((items: GroupOptionsItemType) => {
    items.children?.forEach((i: GroupChildrenItemType) => {
      const item = { [i.value]: i.text };
      result = { ...result, ...item };
    });
  });
  return result;
};